import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0205 from "../lesson-05/lesson";
import lesson0206 from "../lesson-06/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "22802113-67db-4f9c-a506-bc2e3f10ed2c",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0205),
    lesson: lesson0205,
  },
  {
    id: "5d54cb2f-000b-40f3-a849-beeedc0c03ea",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0206),
    lesson: lesson0206,
  },
];

export default lessonLinks;
